import React, { useEffect, useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function WhatToExpectSection() {
  const [activeStep, setActiveStep] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const headerReveal = useScrollReveal({
    threshold: 0.1
  });
  // Data
  const steps = [{
    period: '24-48 HOURS',
    title: 'Adapation & Awakening',
    desc: "Notice subtle grounded calm & focus. Some feel nothing yet and that's normal. Trust the process."
  }, {
    period: '1-2 WEEKS',
    title: 'The Fog Begins to Lift',
    desc: "The mental noise quiets. You catch yourself responding calmly to your old triggers. Prayer feels less scattered. You're not fighting your brain as much."
  }, {
    period: '1 MONTH',
    title: 'Cognitive Clarity',
    desc: 'You finish tasks. You remember things. Your present with your kids, life purpose and with god.'
  }, {
    period: '3 MONTHS',
    title: 'The New Normal',
    desc: "The chaos isn't gone life is still life. But you're different & feel whole. The stress fades because you're finally showing up as the warrior God designed you to be."
  }];
  // Auto-advance logic
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveStep(prev => (prev + 1) % steps.length);
    }, 5000); // Change every 5 seconds
    return () => clearInterval(interval);
  }, [isPaused, steps.length]);
  return <section className="relative w-full min-h-[700px] lg:h-[850px] flex flex-col justify-center overflow-hidden font-sans bg-[#0f1a13]" data-id="element-567">
      {/* === 1. CINEMATIC VIDEO BACKGROUND (Brightened for Vitality) === */}
      <div className="absolute inset-0 z-0" data-id="element-568">
        {/* FIX: Removed 'scale-105' to stop the zooming/low-res issue on desktop. kept blur for atmosphere */}
        <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/ezgif-41ade0920902232a.gif?v=1764234157" alt="Saffron Capsule Technology" className="w-full h-full object-cover object-center blur-[3px]" data-id="element-569" />

        {/* VITALITY OVERLAY:
            FIX: Significantly reduced opacity to create a lighter, high-end "Apple" backdrop.
            0.1 (center) to 0.4 (edge) allows much more light through.
         */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(15,26,19,0.1)_0%,rgba(15,26,19,0.4)_100%)]" data-id="element-570"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-full flex flex-col justify-center py-12 lg:py-0" data-id="element-571">
        {/* === HEADER === */}
        <div ref={headerReveal.ref} className={`text-center mb-10 lg:mb-14 transition-all duration-1000 ${headerReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-572">
          {/* Main Title - Premium & Bright */}
          <h2 className="text-4xl sm:text-5xl lg:text-7xl font-serif text-transparent bg-clip-text bg-gradient-to-b from-white via-[#fffaf0] to-[#eaddcf] drop-shadow-[0_4px_20px_rgba(0,0,0,0.3)] tracking-tight pb-3 leading-tight" data-id="element-573">
            What to Expect
          </h2>

          {/* Elegant Divider */}
          <div className="flex items-center justify-center gap-4 mt-2 opacity-90" data-id="element-574">
            <div className="h-[1px] w-8 sm:w-16 bg-gradient-to-r from-transparent to-[#c9a962]" data-id="element-575"></div>
            <div className="w-1.5 h-1.5 rounded-full bg-[#c9a962] shadow-[0_0_15px_#c9a962]" data-id="element-576"></div>
            <div className="h-[1px] w-8 sm:w-16 bg-gradient-to-l from-transparent to-[#c9a962]" data-id="element-577"></div>
          </div>
        </div>

        {/* === CENTERED CONTENT === */}
        <div className="w-full flex justify-center" data-id="element-578">
          {/* GLASS INTERFACE
           - Lighter background (bg-black/30 instead of /60)
           - Increased padding (p-10 lg:p-12) for better spacing
           - max-w-3xl to prevent it from looking stretched
           */}
          <div className="w-full max-w-3xl bg-[#0f1a13]/40 backdrop-blur-xl border border-white/10 rounded-[2rem] p-5 sm:p-8 lg:p-12 shadow-2xl ring-1 ring-white/5" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-579">
            <div className="flex flex-col gap-4 lg:gap-6" data-id="element-580">
              {steps.map((step, index) => {
              const isActive = activeStep === index;
              return <div key={index} onClick={() => setActiveStep(index)} className={`relative pl-5 sm:pl-6 lg:pl-8 py-3 sm:py-5 cursor-pointer group rounded-xl transition-all duration-500 ${isActive ? 'bg-white/10 shadow-lg scale-[1.01]' : 'hover:bg-white/5'}`} data-id="element-581">
                    {/* Active Progress Bar (Gold Glow) */}
                    {isActive && <div className="absolute left-0 top-3 bottom-3 w-[3px] bg-[#c9a962] rounded-r-full overflow-hidden shadow-[0_0_15px_rgba(201,169,98,0.6)]" data-id="element-582">
                        {!isPaused && <div className="absolute top-0 left-0 w-full h-full bg-[#fff5d6] animate-[progress_5s_linear] origin-top" data-id="element-583"></div>}
                      </div>}

                    {/* Content */}
                    <div className={`transition-all duration-300 ${isActive ? 'opacity-100' : 'opacity-60 group-hover:opacity-90'}`} data-id="element-584">
                      <div className="flex justify-between items-baseline mb-1 lg:mb-2" data-id="element-585">
                        <span className={`text-[10px] sm:text-xs lg:text-sm font-bold tracking-[0.2em] uppercase ${isActive ? 'text-[#c9a962]' : 'text-white/70'}`} data-id="element-586">
                          {step.period}
                        </span>
                      </div>

                      {/* Typography */}
                      <h3 className={`font-serif text-white mb-1 sm:mb-2 transition-all duration-300 ${isActive ? 'text-lg sm:text-2xl lg:text-3xl drop-shadow-sm' : 'text-base sm:text-xl lg:text-2xl'}`} data-id="element-587">
                        {step.title}
                      </h3>

                      {/* Description Expansion */}
                      <div className={`grid transition-all duration-500 ease-in-out ${isActive ? 'grid-rows-[1fr] opacity-100 mt-2 sm:mt-3' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-588">
                        <div className="overflow-hidden" data-id="element-589">
                          <p className="text-gray-100 text-sm sm:text-base lg:text-lg leading-relaxed font-light max-w-2xl" data-id="element-590">
                            {step.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-591">{`
        @keyframes progress {
          from { height: 0%; }
          to { height: 100%; }
        }
      `}</style>
    </section>;
}